import { useTranslation } from 'react-i18next';

import { TriggerActionType } from 'models/automation/Triggers';

interface TriggerActionTypeCellProps {
  getValue: () => TriggerActionType;
}

const TriggerActionTypeCell = ({ getValue }: TriggerActionTypeCellProps) => {
  const { t } = useTranslation();
  const actionType = getValue();

  if (!actionType) {
    return '';
  }

  return t('pageAutomations.common.triggerActionType', {
    context: actionType,
  });
};

export default TriggerActionTypeCell;
